<mat-card>
  <mat-toolbar-row>
    <h3>{{ 'Open Files' | translate }}</h3>
  </mat-toolbar-row>
  <mat-card-content>
    <ix-table2
      class="table"
      [ix-table2-empty]="!(dataProvider.currentPageCount$ | async)"
      [emptyConfig]="emptyService.defaultEmptyConfig(dataProvider.emptyType$ | async)"
    >
      <thead
        ix-table-head
        [columns]="columns"
        [dataProvider]="dataProvider"
      ></thead>
      <tbody
        ix-table-body
        [columns]="columns"
        [dataProvider]="dataProvider"
        [isLoading]="dataProvider.isLoading$ | async"
      ></tbody>
    </ix-table2>
    <ix-table-pager [dataProvider]="dataProvider"></ix-table-pager>
  </mat-card-content>
</mat-card>
